"use strict";

angular.module("customer")
.component("catalogSharingTypeIcon", {
    templateUrl: require("./catalog-sharing-type-icon.component.html"),
    css: [require("./catalog-sharing-type.useable.scss")],
    controllerAs: "catalogSharingTypeIconCtrl",
    bindings: {
        sharingType: "<"
    }
})
.component("catalogSharingType", {
    templateUrl: require("./catalog-sharing-type.component.html"),
    css: [require("./catalog-sharing-type.useable.scss")],
    controllerAs: "catalogSharingTypeCtrl",
    bindings: {
        sharingType: "<",
        group: "<"
    }
});



//////////////////
// WEBPACK FOOTER
// ./customer/app-core/catalog-sharing-type/catalog-sharing-type.component.js
// module id = 821
// module chunks = 0